import { render, staticRenderFns } from "./MedicHistory.vue?vue&type=template&id=6208a16c"
import script from "./MedicHistory.vue?vue&type=script&lang=js"
export * from "./MedicHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports